var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLinkV = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.772 5.191a.538.538 0 1 1 .761.759L1.391 7.091A1.075 1.075 0 0 0 2.913 8.61l2.663-2.659a.537.537 0 0 0 0-.759.538.538 0 1 1 .761-.76 1.61 1.61 0 0 1 0 2.279L3.674 9.37A2.151 2.151 0 1 1 .63 6.331l1.142-1.14zm6.455-.383a.538.538 0 1 1-.761-.759l1.142-1.14a1.075 1.075 0 1 0-1.523-1.52l-2.662 2.66a.537.537 0 0 0 0 .759.538.538 0 1 1-.761.76 1.61 1.61 0 0 1 0-2.279L6.325.629a2.151 2.151 0 1 1 3.044 3.039L8.227 4.809z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLinkV);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/link-v.6c06c4ed6e5b582b36f8d16d0486d26f.svg";